var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-header g-mb-16"},[_c('b-crumb',{attrs:{"list":_vm.crumb,"no-mb":""}}),_c('div',{staticClass:"search"},[_c('search-plate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }